import React from 'react'

const OfficeAtmosphereSection = () => {
  const officeImages = [
    '/img/about-us/2.jpg',
    '/img/about-us/3.jpg',
    '/img/about-us/4.jpg',
    '/img/about-us/5.jpg',
    '/img/about-us/6.jpg',
    '/img/about-us/7.jpg',
  ]

  return (
    <section className="bg-white py-16 lg:py-24">
      {/* Section Header */}
      <div className="container mx-auto mb-12 px-4 text-center lg:px-12">
        <h2 className="mb-6 text-3xl font-bold lg:text-5xl">
          <span className="text-gray-800">Suasana</span>
          <span className="text-red-600"> Kantor Kami</span>
        </h2>

        <p className="mx-auto max-w-3xl text-lg leading-relaxed text-gray-600 lg:text-xl">
          Di YES, kami selalu berusaha menyediakan suasana bekerja yang baik
          untuk mendukung kenyamanan pegawai.
        </p>
      </div>

      {/* Image Carousel */}
      <div className="relative overflow-hidden rounded-xl">
        <div className="animate-scroll-right flex">
          {/* First set */}
          {officeImages.map((image, index) => (
            <div key={`first-${index}`} className="mr-6 flex-shrink-0">
              <img
                src={image}
                alt={`Office atmosphere ${index + 1}`}
                className="h-72 w-96 object-cover shadow-lg transition-shadow duration-300 hover:shadow-xl lg:h-80 lg:w-[500px]"
              />
            </div>
          ))}

          {/* Duplicate set for seamless loop */}
          {officeImages.map((image, index) => (
            <div key={`second-${index}`} className="mr-6 flex-shrink-0">
              <img
                src={image}
                alt={`Office atmosphere ${index + 1}`}
                className="h-72 w-96 object-cover shadow-lg transition-shadow duration-300 hover:shadow-xl lg:h-80 lg:w-[500px]"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Gradient Overlay for fade effect */}
      <div className="pointer-events-none absolute bottom-0 left-0 top-0 w-20 bg-gradient-to-r from-white to-transparent"></div>
      <div className="pointer-events-none absolute bottom-0 right-0 top-0 w-20 bg-gradient-to-l from-white to-transparent"></div>

      {/* Custom CSS for animation */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @keyframes scroll-right {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          
          .animate-scroll-right {
            animation: scroll-left 20s linear infinite;
          }
          
          .animate-scroll-right:hover {
            animation-play-state: paused;
          }
        `,
        }}
      />
    </section>
  )
}

export default OfficeAtmosphereSection
